import {
    Component,
    Input,
    OnDestroy,
    ChangeDetectionStrategy,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormGroupType } from '../../../../../../core/models/form-group-type';
import { Subject } from 'rxjs';
import { ScheduleDFormModel } from '../../models/schedule-d-form-model';

@Component({
    selector: 'app-schedule-d-step-base',
    changeDetection: ChangeDetectionStrategy.Eager,
    template:
        '<!-- This component serves as a base and does not render any content -->',
})
export class ScheduleDStepBaseComponent implements OnDestroy {
    @Input() form!: FormGroup<FormGroupType<ScheduleDFormModel>>;
    protected readonly destroy$ = new Subject<void>();

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
